import { Badge, Flex, Stack, Text } from '@mantine/core';
import React from 'react';

interface TargetAudienceProps {
  data: any;
  title?: string;
}

const TargetAudience: React.FC<TargetAudienceProps> = ({
  data,
  title = 'Target Audience'
}) => {
  return (
    <Stack gap={4}>
      <Text fw={700} fz={12} c={'gray'}>
        {title}
      </Text>
      <Flex gap={4} align={'center'} wrap={'wrap'}>
        {!data && '-'}
        {data &&
          data.split(',').map((tag, i) => {
            return (
              <Badge key={i} variant="outline" color="gray" radius="sm" fz={10}>
                {tag}
              </Badge>
            );
          })}
      </Flex>
    </Stack>
  );
};

export default TargetAudience;
